export default function InteractionChart({ data, growth }) {
  const maxValue = Math.max(...data.map(d => d.total));

  return (
    <div className="card-wrapper !p-4 !rounded-2xl">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-black mb-1">Total Interactions</h3>
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-purple-500"></div>
              <span className="text-gray-600">Total Interactions</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-cyan-400"></div>
              <span className="text-gray-600">Post Total Interactions</span>
            </div>
          </div>
        </div>
        <div
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg ${
            growth >= 0
              ? 'text-emerald-400 bg-emerald-400/10'
              : 'text-red-400 bg-red-400/10'
          }`}
        >
          <span className="text-sm font-medium">
            {growth >= 0 ? '▲' : '▼'} {Math.abs(growth)}%
          </span>
          <span className="text-xs text-gray-600">Interaction Growth</span>
        </div>
      </div>

      <div className="relative h-48">
        <div className="absolute inset-0 flex items-end justify-between">
          {data.map((point, index) => {
            const heightTotal = (point.total / maxValue) * 100;
            const heightPost = (point.postTotal / maxValue) * 100;

            return (
              <div key={index} className="flex-1 flex items-end justify-center gap-1 group relative">
                <div className="relative flex items-end gap-0.5">
                  <div
                    className="w-2 bg-purple-500 rounded-t transition-all group-hover:bg-purple-400"
                    style={{ height: `${heightTotal * 1.5}px` }}
                  ></div>
                  <div
                    className="w-2 bg-cyan-400 rounded-t transition-all group-hover:bg-cyan-300"
                    style={{ height: `${heightPost * 1.5}px` }}
                  ></div>
                </div>
                <div className="absolute -bottom-6 text-xs text-gray-600">
                  {point.date}
                </div>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity absolute -top-12 text-black px-2 py-1 rounded text-xs whitespace-nowrap z-10">
                  <div>Total: {point.total.toLocaleString()}</div>
                  <div>Post: {point.postTotal.toLocaleString()}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="absolute left-0 top-0 h-full flex flex-col justify-between text-xs text-gray-500">
          <span>{Math.round(maxValue).toLocaleString()}</span>
          <span>{Math.round(maxValue / 2).toLocaleString()}</span>
          <span>0</span>
        </div>
      </div>

      <div className="mt-8 text-xs text-gray-600 text-center">March</div>
    </div>
  );
}
